import { ErrorPage_Default } from "@ubnt/ui-components/aria/ErrorPage";

export const ErrorPageGeneric: React.FC = () => {
  return (
    <ErrorPage_Default
      title="Oops!"
      actionButtonText="Reload"
      description="Something went wrong, please try to reload the page."
      actionButtonProps={{ onClick: () => window.location.reload() }}
    />
  );
};
